import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
import "../AllPrint.css";
class RentPrintKurdish extends Component {
 render() {
  const {
   lang,
   change_Lang,
   rent_invoice_obj,
   user,
   thirdcolor,
   primary_logo,
   index_rentcontrct,
   footer_logo,
   name_krd,
  } = this.props;
  // Kurdish
  let numberWordsSorani1 =
   rent_invoice_obj.introduction !== undefined &&
   rent_invoice_obj.introduction !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.introduction.toString().replace(/,/g, ""))
      )
    : 0;
  let numberWordsSorani2 =
   rent_invoice_obj.paymentmonth !== undefined &&
   rent_invoice_obj.paymentmonth !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.paymentmonth.toString().replace(/,/g, ""))
      )
    : 0;
  let numberWordsSorani3 =
   rent_invoice_obj.feelate !== undefined && rent_invoice_obj.feelate !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.feelate.toString().replace(/,/g, ""))
      )
    : 0;
  let numberWordsSorani4 =
   rent_invoice_obj.safly !== undefined && rent_invoice_obj.safly !== null
    ? KurdishSoraniNumbersToWords.convert(
       parseFloat(rent_invoice_obj.safly.toString().replace(/,/g, ""))
      )
    : 0;

  return (
   <>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <div className={` ${lang !== "en" ? "fk" : "fkp"}`}>
     <div className="row">
      <div className="col-12">
       <div className="conn">
        <div class="row">
         <div class="col-4">
          <p
           style={{
            fontSize: "22px",
            color: "#000",
            textAlign: "right",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
           <Time
            value={rent_invoice_obj.createdAt}
            format="YYYY-MM-DD"
            style={{
             fontSize: "22px",
             color: "#000",
             fontWeight: "bold",
            }}
           />
          </p>
         </div>
         <div class="col-4 d-flex justify-content-center">
          <p
           style={{
            fontSize: "25px",
            color: "#000",
            fontWeight: "bolder",
           }}
           class={`d-flex justify-content-center text-uppercase ${
            lang !== "en" ? "fk" : "fkp"
           } `}
          >
           ({change_Lang("Rental contract")})
          </p>
         </div>
         <div class="col-4 text-right">
          <p
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           {change_Lang("contract number")} #&nbsp;
           {index_rentcontrct}&nbsp;
          </p>
         </div>
        </div>
        <div class="row">
         <div class="col-12">
          <div class="form-group row form-inline">
           <label
            style={{
             fontSize: "23px",
             color: "black",
             fontWeight: "bolder",
            }}
            class="col-sm-3 col-form-label d-flex justify-content-start fkk"
           >
            لایەنی یەکەم(خاوەن موڵك):
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.firstname}
            </label>
           </div>
           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            لايەنى دووەم (کرێچی):
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
            </label>
           </div>
           {/* phone */}
           {/* <label
                        style={{
                          fontSize: "25px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                        class="col-sm-3 col-form-label fkk d-flex justify-content-start"
                      >
                        ژمارەی مۆبایل:
                      </label>
                      <div class="col-sm-3">
                        <label
                          class="d-flex justify-content-start"
                          style={{ fontWeight: "bold", fontSize: "22px" }}
                        >
                          {rent_invoice_obj.phone1}
                        </label>
                      </div>
                      <label
                        style={{
                          fontSize: "25px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                        class="col-sm-3 col-form-label fkk d-flex justify-content-start"
                      >
                        ژمارەی مۆبایل:
                      </label>
                      <div class="col-sm-3">
                        <label
                          class="d-flex justify-content-start"
                          style={{ fontWeight: "bold", fontSize: "22px" }}
                        >
                          {rent_invoice_obj.tenantId &&
                            rent_invoice_obj.tenantId.phone2}
                        </label>
                      </div> */}
           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {" "}
            {change_Lang("first_rule_place")}:
           </label>
           <br />
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.Place_ku}
            </label>
           </div>

           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {change_Lang("Type of property")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {change_Lang(
              rent_invoice_obj.available_id &&
               rent_invoice_obj.available_id.Property
             )}
            </label>
           </div>
           {/* Area */}
           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {" "}
            {change_Lang("Number of property")}:
           </label>

           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.NOoFProperty}
            </label>
           </div>

           <label
            style={{
             fontSize: "25px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk d-flex justify-content-start"
           >
            {change_Lang("Area")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {rent_invoice_obj.available_id &&
              rent_invoice_obj.available_id.Area}
             &nbsp;م<sup>2</sup>
            </label>
           </div>
          </div>
          <p
           style={{
            fontSize: "22px",
            color: "#fff",
            fontWeight: "bold",
            borderRadius: "50px 0px 0px 0px",
           }}
           id="liniar"
           class="my-0 d-flex justify-content-center fk"
          >
           {change_Lang("agreement")}
          </p>
         </div>
        </div>
        <div className="row">
         <div className="col-12">
          <table className="table">
           <tbody>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
             className="p-0 m-0"
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              -
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              به‌پێى ئه‌وه‌ى لايه‌نه‌ى دووه‌م پێويستى به‌ يه‌كه‌ى نيشته‌جێبوونه‌
              به‌مه‌به‌ستى {rent_invoice_obj.perpose}، وبه‌پێى ئه‌وه‌ى لايه‌نى
              يه‌كه‌م خاوه‌ن يه‌كه‌كه‌يه‌ وبه‌نيازه‌ به‌كرێيبدا، ئه‌وه‌
              هه‌ردوولا ڕه‌زامه‌ندبوون له‌سه‌ر واژووكردنى گرێبه‌ستى كرێ وه‌
              ڕيككه‌وتن له‌سه‌ر ئه‌م خاڵ وبڕگانه‌ى خواره‌وه‌ :
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
             className="p-0 m-0"
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              1-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایه‌نی یه‌كه‌م ڕه‌زامه‌نده‌ له‌سه‌ر به‌ كرێدانی ئه‌م موڵكه‌ی له‌
              سه‌ره‌وه‌ دیاری كراوه به ژماره‌ به‌ لایه‌نی دووه‌م بۆ ماوه‌ی (
              {Math.floor(Number(rent_invoice_obj.rental) / 12)}) ساڵ له‌
              رێكه‌وتی (
              <Time
               value={rent_invoice_obj.startdate}
               format="YYYY-MM-DD"
               style={{
                color: "black",
               }}
              />
              ) تاكو (
              <Time
               value={rent_invoice_obj.enddate}
               format="YYYY-MM-DD"
               style={{
                color: "black",
               }}
              />
              ) كه‌ هه‌ردوولا ڕه‌زامه‌ندن له‌سه‌ر بڕى كرێیه‌كه‌ كه‌ بريتيه‌ له‌
              (&nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.paymentmonth}
               style={{}}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
              />
              &nbsp;
              {numberWordsSorani2}&nbsp;
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "($)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              ) بۆ ماوه‌ى {Math.floor(Number(rent_invoice_obj.rental) / 12)}{" "}
              ساڵ.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              2-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              پێشەکی گرێبەست بەشێکە لەم گرێبەستە لێی جیا نابێتەوە.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              3-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایه‌نی دووه‌م بڕی ({" "}
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.introduction}
               style={{}}
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
               className="text-center"
              />
              &nbsp;
              {numberWordsSorani1}
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "($)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              ) ده‌دات به‌ لایه‌نی یه‌كه‌م وه‌كو پێشه‌كی (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.Monthintroduction}
               className="text-center"
              />
              ) مانگ، دوای ئه‌وه‌ لایه‌نی دووه‌م هه‌ر (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={rent_invoice_obj.MonthForRent}
               className="text-center"
              />
              )مانگ جارێك كرێیه‌كه‌ راده‌ستی كۆمپانیای (دیڤاین تایم) ده‌كات.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              4-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایه‌نی دووه‌م پێويسته‌ بڕی (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               style={{}}
               value={rent_invoice_obj.safly}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
              />
              &nbsp;
              {numberWordsSorani4}
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "($)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              ) دولارى ئه‌مریكی وه‌كو دڵنیایی دابنێت له‌لایه‌ن كۆمپانیای (دیڤاین
              تایم) ئه‌و بڕه‌ پاره‌یه‌ ده‌گه‌رێته‌وه‌ بۆ لایه‌نی دووه‌م دوای
              راده‌ستكردنی موڵكه‌كه‌ به‌بێ هیچ كه‌م و كوریه‌ك وه‌ پاكتاوكردنى
              سه‌رجه‌م خزمه‌تگوزاريه‌كان وكاره‌با وئاو (حكومى و تايبه‌ت به‌
              پرۆژه‌كه‌) وه‌ نه‌بوونى هيچ كه‌م وكورێيك له‌ مولكه‌كه‌ وه‌
              به‌هه‌مان شێوه‌ى خۆى به‌ر له‌ به‌كرێگرتنى.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              5-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              ئه‌گه‌ر بێتو كرێچی (لايه‌نى دووه‌م) ویستی گرێبه‌سته‌كه‌
              هه‌لبوه‌شێنیته‌وه‌ یان موڵكه‌كه‌ به‌تال بكات پێش (6)شه‌ش مانگی
              یه‌كه‌م به‌ر له‌ ته‌واوبوونى ماوه‌ى گرێبه‌سته‌كه‌ ئه‌‌وا بڕى
              دڵنيايى (تأمينات) كه‌‌ له‌‌ به‌ندى چواره‌م ئاماژه‌ى پێكراوه‌ بۆى
              ناگه‌رێته‌وه‌ تاكو مولكه‌كه‌ دووباره‌ به‌كرێده‌چێت وه‌ ئه‌و ماوه‌ى
              مولكه‌كه‌ به‌به‌تاڵى ده‌مێنێته‌وه‌ هه‌ژمارده‌كرێت و بری ماوه‌ بۆی
              ده‌گه‌رێته‌وه‌.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              6-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              ئه‌گه‌ر هاتوو لایه‌نی دووه‌م (كرێچی) به‌ر له‌ ته‌واو بوونی واده‌ی
              گرێبه‌سته‌كه‌ ویستی موڵكه‌كه‌ به‌تال بكات ئه‌وا ده‌بێت پێش (1)
              یه‌ك مانگ خاوه‌ن مۆلك ئاگادار بكاته‌وه‌، به‌ پێچه‌وانه‌ی ئه‌م
              به‌نده‌ تاكو مولكه‌كه‌ دووباره‌ به‌ كرێ ده‌چێته‌وه‌ كرێ له‌سه‌ر
              لایه‌نی دووه‌می ئه‌م گرێبه‌سته‌ (كرێچی) هه‌ژمار ده‌كرێت .
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              7-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              ئه‌گه‌ر موڵكه‌كه‌ ڕاخراو بوو (مؤثث)، له‌سه‌ر هه‌ردوولا پێویسته‌
              كه‌ل و په‌له‌كان ئه‌ژمار (جرد) بكه‌ن و وێنه‌ی بگرن و هاوپێچی
              گرێبه‌سته‌كه‌ بكرێت بۆ زانین به‌ر له‌ به‌كرێدانی.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <div className="conn">
        <div className="row">
         <div className="col-12">
          <table className="table">
           <tbody>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              8-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              ئه‌گه‌ر موڵكه‌كه‌ ڕاخراو بوو (مؤثث)، لایه‌نی دووه‌م پێویسته‌
              پارێزگاری له‌ كه‌ل و په‌له‌كان بكات و له‌ كاتی ده‌رچوونی وه‌ك خۆی
              ڕادەستی لایه‌نی یه‌كه‌م بكات، به‌ پێچه‌وانه‌وه‌ لایه‌نی دووه‌م
              به‌رپرسه‌ له‌ چاككردنه‌وه‌ى زيانه‌كان‌ یان گۆڕین له‌سه‌ر ئه‌ستۆى
              خۆی.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               fontSize: "20px",
              }}
              scope="row"
             >
              9-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              ئه‌گه‌ر یه‌كه‌ی نیشته‌جێبوون یان بازرگانی (مؤثث) بوو ئه‌وا
              كۆمپانیای (دیڤاین تایم) هه‌ڵده‌ستێت به‌ ڕه‌زامه‌ندی لایه‌نی
              یه‌كه‌م و دووه‌م به‌(جرد) كردنى كه‌ل و په‌لی ناو یه‌كه‌كه‌ و به‌
              وێنه‌ و ئه‌رشیف ده‌كرێت له‌گه‌ل گرێبه‌سته‌كه‌ به‌ر له‌ به‌كرێدانى.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              10-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایه‌نی یه‌كه‌م پێش ئه‌وه‌ی موڵكه‌كه‌ی به‌ كرێ بدات پێويسته‌
              پاره‌ی ئاو و كاره‌باى (حكومى وپرۆژه‌) پاكتاو بكات و ته‌سفیه‌ی
              زه‌ریبه بكات‌ ئه‌گه‌ر هه‌بوو و هه‌ر خزمه‌تگوزاریه‌كی تر و خاوێن
              كردنه‌وه‌ی موڵكه‌كه‌ له‌ ئه‌ستۆی ده‌بێت به‌ر له‌ پێدانى كليل به‌
              كرێچى.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              11-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              کرێی ئاو و کارەبا (حكومى و تايبه‌ت به‌ پڕۆژه‌) و هەموو
              خزمەتگوزاریەکانى تر لە ئەستۆی لایەنی دووەم دەبێت له‌ ماوه‌ى
              به‌كرێگرتنى وه‌ سه‌رجه‌م پسووله‌كان ڕاده‌ستى كۆمپانياى (دیڤاین
              تایم) بكات، وە لە کاتی تەواو بوونی گرێبەستی کرێ دەبێت لایەنی دووەم
              پارەی ئاو و کارەبا و هیچ جۆرە خزمەتگوزاریەکی لە ئەستۆ نەما بێت.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              12-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "22px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایەنی دووەم موڵکی بابەتی گرێبەست دەبێت بەو شێوەیە بەکاربهێنێت کە
              گرێبەستی لەسەر کردووە کە بۆ بازرگانی یان نیشتەجێ بوون بە
              پێجەوانەوە دەبێت لايه‌نى دووه‌م بڕى &nbsp;(
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               style={{}}
               value={rent_invoice_obj.feelate}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
              />
              &nbsp;
              {numberWordsSorani3}
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "($)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              )&nbsp;بدات وه‌ك پێبژاردن بۆ هه‌ر رۆژێك له‌ سه‌رپێچى.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              13-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایەنی دووەم بۆی نیە هەموو یان بەشێکی موڵکەکە بە کرێ بداتەوە تەنها
              بەڕەزامەندی لایەنی یەکەم نەبێت كه‌ بە شێوەیەی نوسين (تحريري) بێت،
              بە پێجەوانەوە بە ( ايجار من الباطن ) هەژماردەکرێت و دەبێتە هۆی
              کۆتایی هاتنی گرێبەست وە لایەنی دووەم هیچ مافێکی قەرەبووی نابێت.
             </td>
            </tr>

            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              14-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایەنی دووەم بۆی نیە دەستکاری موڵکی بەکرێ دراو و كه‌ل وپه‌له‌كانى
              ناوى بکات بە هیچ شێوەیەک تەنها بە ڕەزامەندی لایەنی یەکەم نەبێت،
              بەپێچه‌وانه‌وه‌ گرێبه‌سته‌كه‌ به‌تاڵ ده‌بێته‌وه‌ ولايه‌نى دووه‌م
              نيه‌ داواى هيچ قه‌ره‌بویەك بكاته‌وه‌.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              15-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              کۆمپانیاکەمان (دیڤاین تایم) بەر پرسیار نابێت لە نەدانی کرێی لایەنی
              دووەم، بەڵکو لایەنی یەکەم دەتوانێت هامووشۆی دادگا بکات بۆ
              وەرگرتنەوەی مافی خۆی لە لایەنی دووەم، وە لەکاتی پەنا بردنە بەر
              دادگای تایبەتمەند ئەوا لە کاتی پێویست كۆمپانیاكه‌مان ڕوونکرنەوە
              دەدات بە دادگا دوای ئاگەدار کردنەوەی بە پێی ڕاگەیاندنی فەرمی.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              16-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              ئه‌گه‌ر لایه‌نی یه‌كه‌م هه‌ڵسا به‌ فرۆشتنی موڵكه‌كه به‌ر
              له‌ته‌واوبوونى ماوه‌ى به‌كرێدان‌ ئه‌وا لایه‌نی دووه‌م بۆی هه‌یه‌
              له‌ناوى بمێنێته‌وه‌ تا كوتایی واده‌ی گرێبه‌سته‌كه‌ ، و خاوه‌نه‌
              نوێێه‌كه‌ پابه‌ند ده‌بێت به‌ ناوه‌رۆكی ئه‌م گرێبه‌سته‌.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <div className="conn">
        <div className="row">
         <div className="col-12">
          <table className="table">
           <tbody>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              17-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              هەردوولایەنی گرێبەست پێویستە بڕی پارەی (50%)لە کرێی یەک مانگ هەموو
              ساڵێک یەک جار بدەن بە کۆمپانیا وەکو کۆمیشن لەبڕی ئەو
              خزمەتگوزاریانەی بۆ بەکرێ دانی موڵکەکە.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              18-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایه‌نی دووه‌م تا رێكه‌وتی (
              <Time
               value={rent_invoice_obj.duedate}
               format="YYYY-MM-DD"
               style={{
                fontSize: "22px",
                color: "#000",
                fontWeight: "bold",
               }}
              />
              ) گه‌ر نه‌یتوانی رێگه‌پێدانی لایه‌نی په‌یوه‌ندیدار وه‌ربگرێت
              ،ئه‌وا گرێبه‌سته‌كه‌ راسته‌وخۆ هه‌لده‌وه‌شێته‌وه‌ و لایه‌نی دووه‌م
              پاره‌كه‌ وه‌رده‌گرێته‌وه‌.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              19-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایه‌نی دووه‌م بۆی نیه‌ داوای كلیلی موڵكه‌كه‌ بكات بۆ هه‌ر
              مه‌به‌ستێك بێت تا ڕێپێدان له‌لایه‌نی په‌یوه‌ندیدار یان ئاسایش
              وه‌رنه‌گرێت كه‌له‌برگه‌ى سه‌ره‌وه‌ ئاماژه‌ى پێكراوه‌ وه‌ هه‌بونى
              مۆرى فه‌رمى له‌سه‌ر گرێبه‌سته‌كه‌.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              20-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لایه‌نی دووه‌م پابه‌ند ده‌بێت به‌ پێدانی كرێیه‌كه هه‌موو جارێك
              به‌ته‌واوى ‌(7) رۆژ پێش رێكه‌وتی دیاری كراو و ئه‌گه‌ر (7) رۆژ له‌
              واده‌ی دیاریكراو دواكه‌وت ئه‌وا لایه‌نی دووه‌م به‌رپرسیار ده‌بێت
              به‌رامبه‌ر به‌ یاسا به‌پێی مادده‌ی (17) بڕگه‌ی (1) له‌ یاسای به‌
              كرێدانی عێراقی ژماره‌ (87) سالی (1979).
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              21-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "22px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              دوای ته‌واوبوونی ماوه‌ی گرێبه‌سته‌كه‌ ئه‌وا لایه‌نی دووه‌م ده‌بێ
              پابه‌ندبێت به‌ چولكردنی موڵكه‌كه‌ یان نوێ ‌كردنه‌وه‌ی
              گرێبه‌سته‌كه‌ به‌پێچه‌وانه‌وه‌ ئه‌‌وا لايه‌نى دووه‌م پابه‌ند
              ده‌بێت ڕوژانه‌‌ بڕى &nbsp;(
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               style={{}}
               value={rent_invoice_obj.feelate}
               className="text-center"
               prefix={`${rent_invoice_obj.currency === "dolar" ? "$" : "ID"}`}
              />
              &nbsp;
              {numberWordsSorani3}
              {lang === "en" && rent_invoice_obj.currency === "dolar"
               ? "($)"
               : lang === "krd" && rent_invoice_obj.currency === "dolar"
               ? "(دۆلار)"
               : lang === "arb" && rent_invoice_obj.currency === "dolar"
               ? "(دولار)"
               : lang === "en" && rent_invoice_obj.currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : lang === "arb" && rent_invoice_obj.currency !== "dolar"
               ? "(دینار)"
               : ""}
              )&nbsp;وه‌ك غرامه‌ بدات‌ تا گه‌يشتن به‌ رێكه‌وتنێكى ياخوود تاوه‌كو
              كاتى چۆلكردنى مولكه‌كه‌.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              22-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              هه‌ردوو لايه‌ن پابه‌ند ده‌بن به‌وه‌ى كه‌ سه‌رجه‌م مامه‌ڵه‌
              داراييه‌كان له‌ پێدان و وه‌رگرتنى كرێ له‌ رێگاى كۆمپانياى (دیڤاین
              تایم) ئه‌نجامبدرێت.
             </td>
            </tr>

            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              23-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              دوای كوتایی هاتنی ماوه‌ی گرێبه‌سته‌كه‌ ئه‌گه‌ر هاتوو هه‌ردوولایه‌ن
              ره‌زامه‌ند بوون له‌سه‌ر نوێكردنه‌وه‌ی گرێبه‌سته‌كه‌ به‌ نرخی رۆژ
              ئه‌وا كۆمپانیای (دیڤاین تایم) گرێبه‌ستى نوێيان بۆ‌ ئه‌نجام ده‌دات
              ، و هەردوولایەنی گرێبەست بری پارەی (%50) له‌ كرێی یه‌ك مانگ دەدەن
              بە کۆمپانیا لە بری ئەو خزمەتگوزاریەی لە خوارەوە ئاماژە پێ كراوە لە
              لایەن کۆمپانیا پێشکەش دەكرێت
              <br />
              1-یارمەتی دان و بەرێوەبردنی هەموو كارە ئیداریەكان.
              <br />
              2-لە كاتی نزیك بوونەوەی وەرگرتنی كرێ پەیوەندی كردن بە كرێچی و
              ئاگادار كردنەوەی.
              <br />
              3-وەرگرتنی كرێی مولك و رادەست كردنی بە خاوەن مولك.
              <br />
              4-یارمەتی دانی كرێچی و خاوەن مولك بۆ چارەسەر كردنی هەر كێشەیەك و
              تێكچوونی مولكەكە.
              <br />
              5-ئەگەر هاتوو خاوەن مولك لە دەرەوەی هەرێمی كوردستان بێت رەوانە
              كردنی پارەكەی لە رێگای بەنكەوە و بە پێچەوانەوە.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              24-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              له‌كاتی هەبوونى هه‌ر جياوازێيك له‌روى زمانه‌وانی ياخوود وورده‌كارى
              له‌ نێوان زمانى گرێبه‌سته‌كان ئه‌وا گرێبه‌ستى زمانى كوردی ده‌بێته‌
              سه‌رچاوه‌ و پشتى پێ ده‌بسترێت نه‌وه‌ك عربی و انگليزي .
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              25-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               fontSize: "23px",
               textAlign: "justify",
               borderTop: "none",
              }}
             >
              لەكاتی تەواو بوونی گرێبەستەكە لایەنی دووەم بۆی نیە داوای گەڕانەوەی
              تێچووی گۆرانكارییەكان بكات بە هیچ شێوەیەك لەلایەنی یەكەم دوای
              دەرچوونی لە مۆلكەكەدا.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />
       {/* three */}
       <div className="row">
        <div className="col-12">
         <table className="table">
          <tbody>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             26-
            </th>
            <td
             style={{
              lineHeight: "1.4",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             كۆمپانياى (دیڤاین تایم) بەرپرس نیە لە روودانی هەر كارەساتێكی سروشتی
             یان هەر ئاگركەوتنەوەیەك یان هەر رووداوێكی نەخوازراو.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             27-
            </th>
            <td
             style={{
              lineHeight: "1.4",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             من وەكو كرێچی پابەند دەبم بە دانی كرێ وەكو ئەوەی لە خالەكانی (20)
             بیست و خالی (21)بیست و یەك دا هاتووە ، ئەگەر پابەند نەبووم پێش
             ئەوەی بە رێگای یاسایی ئاگادار بكرێمەوە رەزامەندم بە راگرتنی
             خزمەتگوزاری (ئاو و كارەبا) لەلایەن ئیدارەی پرۆژەكەوە.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             28-
            </th>
            <td
             style={{
              lineHeight: "1.4",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             خاوه‌ن مولك و كرێچی پابه‌ند ده‌بێت به‌و بریاره‌ی له‌لایه‌ن حكومه‌تی
             هه‌ریمی كوردستان ده‌رده‌چێت سه‌باره‌ت به‌ گوریینی جوری دراو له‌
             (دولار) بۆ (دینار) به‌ پێی نرخی ئه‌و رۆژه‌ی كه‌ بریاره‌كه‌
             ده‌رده‌چیت.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             29-
            </th>
            <td
             style={{
              lineHeight: "1.4",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              fontSize: "23px",
              textAlign: "justify",
              borderTop: "none",
             }}
            >
             ئه‌م گرێبه‌سته‌ پێكهاتووه‌ له‌ ( 29 ) بیست و نۆ خاڵ وه‌ سه‌رجه‌م
             بڕگه‌ و خاڵه‌كان پابه‌ندين و به‌شێكن له‌ گرێبه‌سته‌كه‌.
            </td>
           </tr>
          </tbody>
         </table>
        </div>
       </div>
       <div className="form-inline">
        <p
         style={{
          fontSize: "18px",
          color: "black",
          fontWeight: "bold",
          textAlign: "center",
         }}
        >
         {change_Lang("note")}&nbsp;:{rent_invoice_obj.note}
        </p>
       </div>
       <br /> <br />
       <br />
       <br /> <br /> <br />
       <br />
       <br /> <br />
       <br />
       <br /> <br />
       <div className="row">
        <div className="form-group d-flex justify-content-center col-4">
         <label
          style={{
           fontSize: "22px",
           color: "#000",
           fontWeight: "bold",
          }}
          className="form-label"
         >
          لایەنی یەکەم (خاوەنی موڵك)
         </label>
        </div>
        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           ڕێکخەری گرێبەست
          </label>
         </div>
        </div>
        <div className="col-4 d-flex justify-content-center">
         <div className="form-group ">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           لایەنی دووەم (کرێچی)
          </label>
         </div>
        </div>
       </div>
       <div className="row">
        <div className="col-4 form-group d-flex justify-content-center">
         <label
          style={{
           fontSize: "22px",
           color: "#000",
           fontWeight: "bold",
          }}
          className="form-label"
         >
          {rent_invoice_obj.firstname}
         </label>
        </div>
        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {`${rent_invoice_obj.agentId && rent_invoice_obj.agentId.fname} ${
            rent_invoice_obj.agentId && rent_invoice_obj.agentId.lname
           }`}
          </label>
         </div>
        </div>
        <div className="col-4 d-flex justify-content-center">
         <div className="form-group ">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {rent_invoice_obj.tenantId && rent_invoice_obj.tenantId.secondname}
          </label>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  index_rentcontrct: state.Invoice_Reducer.index_rentcontrct,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_krd: state.HelperReducer.name_krd,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentPrintKurdish);
